import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { startCalendarSync, stopCalendarSync } from 'infra/actions/calendars'

import ServiceTable from './ServiceTable'

class ServiceReport extends React.Component {

  static propTypes = {
    teamId: PropTypes.string.isRequired,
    dateStr: PropTypes.string,
    selectedWorkers: PropTypes.array,
    instances: PropTypes.array
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.dateStr !== nextProps.dateStr ||
      this.props.selectedWorkers !== nextProps.selectedWorkers) {
      this.detachLoader(this.props.dateStr, this.props.selectedWorkers)
      this.initLoader(nextProps.dateStr, nextProps.selectedWorkers)
    }
  }

  componentWillMount() {
    this.initLoader(this.props.dateStr, this.props.selectedWorkers)
  }

  componentWillUnmount() {
    this.detachLoader(this.props.dateStr, this.props.selectedWorkers)
  }

  initLoader(dateStr, selectedWorkers) {
    // Query jobs
    for (let i = 0; i < selectedWorkers.length; i++) {
      const workerId = selectedWorkers[i].userId
      const calendarId = `${workerId}@${this.props.teamId}`
      this.props.dispatch(startCalendarSync(calendarId, dateStr))
    }
  }

  detachLoader(dateStr, selectedWorkers) {
    // Query jobs
    for (let i = 0; i < selectedWorkers.length; i++) {
      const workerId = selectedWorkers[i].userId
      const calendarId = `${workerId}@${this.props.teamId}`
      this.props.dispatch(stopCalendarSync(calendarId, dateStr))
    }
  }

  handleServiceRowClicked = info => {
    this.props.dispatch({
      type: 'UI_DIALOG',
      label: 'JOB_SCREEN',
      value: {
        jobInfo: info,
        dateStr: this.props.dateStr
      }
    })
  }

  render() {
    return (
      <div style={styles.container}>
        <ServiceTable
          jobs={this.props.instances}
          dateStr={this.props.dateStr}
          onRowTouchTap={this.handleServiceRowClicked} />
      </div>
    )
  }
}

const styles = {
  container: {
    padding: 24,
    overflow: 'auto',
    flexGrow: 1,
    display: 'flex',
    alignItems: 'stretch'
  }
}

function mapStateToProps(state, ownProps) {
  const teamId = state.firebase.team.metadata.value.id

  const instances = []
  const eventIds = {}
  for (let i = 0; i < ownProps.selectedWorkers.length; i++) {
    const workerId = ownProps.selectedWorkers[i].userId
    const calendarId = `${workerId}@${teamId}`
    const combinedId = `${calendarId}->${ownProps.dateStr}`
    if (state.schedule.instances.hasOwnProperty(combinedId)) {
      const newEvents = state.schedule.instances[combinedId]
        .filter(instance => !eventIds.hasOwnProperty(instance.eventId))
      newEvents.every(instance => eventIds[instance.eventId] = true)
      Array.prototype.push.apply(instances, newEvents)
    }
  }

  return {
    instances,
    teamId
  }
}

export default connect(mapStateToProps)(ServiceReport)



// WEBPACK FOOTER //
// ./src/reports/service/ServiceReport.js